import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import type { LineProductionTargetRequest, TargetBasis } from "@/types/production-targets.types";

interface TargetFormProps {
  isSaving: boolean;
  onSubmit: (payload: LineProductionTargetRequest) => void;
}

/** Segunda-feira da semana de uma data civil, sem envolver fuso. */
function segundaDaSemana(day: string): string {
  const [y, m, d] = day.split("-").map(Number) as [number, number, number];
  const date = new Date(Date.UTC(y, m - 1, d));
  const diff = (date.getUTCDay() + 6) % 7;
  date.setUTCDate(date.getUTCDate() - diff);
  return date.toISOString().slice(0, 10);
}

export function TargetForm({ isSaving, onSubmit }: TargetFormProps) {
  const [basis, setBasis] = useState<TargetBasis>("MONTHLY");
  const [periodStart, setPeriodStart] = useState("");
  // `undefined`, nunca `0` literal: com zero o gestor precisa apagar antes de digitar.
  const [quantity, setQuantity] = useState<number | undefined>(undefined);

  const completo = periodStart !== "" && quantity !== undefined && quantity > 0;

  function enviar() {
    if (!completo) return;
    // A base decide o dia de início aceito: dia 1 no mensal, segunda no semanal. Ajustar aqui evita
    // devolver um 400 por algo que a tela sabe corrigir.
    const inicio =
      basis === "MONTHLY" ? `${periodStart.slice(0, 7)}-01` : segundaDaSemana(periodStart);
    onSubmit({ basis, periodStart: inicio, quantity });
    setPeriodStart("");
    setQuantity(undefined);
  }

  return (
    <div className="grid items-end gap-3 md:grid-cols-4">
      <div className="space-y-1.5">
        <Label htmlFor="target-basis">Base</Label>
        <Select
          id="target-basis"
          value={basis}
          onChange={(e) => setBasis(e.target.value as TargetBasis)}
        >
          <option value="MONTHLY">Mensal</option>
          <option value="WEEKLY">Semanal</option>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="target-period">Período começa em</Label>
        <Input
          id="target-period"
          type="date"
          value={periodStart}
          onChange={(e) => setPeriodStart(e.target.value)}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="target-qty">Meta do período</Label>
        <Input
          id="target-qty"
          type="number"
          placeholder="0"
          value={quantity ?? ""}
          onChange={(e) => setQuantity(e.target.value === "" ? undefined : Number(e.target.value))}
        />
      </div>
      <Button onClick={enviar} disabled={!completo || isSaving}>
        Declarar meta
      </Button>
    </div>
  );
}
